import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { Scheduler } from 'src/app/model/schedulers-data';
import { SchedulerService } from 'src/app/service/scheduler.service';
// import { ClientService } from 'src/app/service/client.service';
// import { ProjectService } from 'src/app/service/project.service';
import { AssignModalComponent } from './assign-modal/assign-modal.component';
import { AssigntargetModalComponent } from './assigntarget-modal/assigntarget-modal.component';
import { SchedulerPageRequest } from 'src/app/model/scheduler-page-request';

@Component({
  selector: 'app-assign-scheduler',
  templateUrl: './assign-scheduler.component.html',
  styleUrls: ['./assign-scheduler.component.scss']
})
export class AssignSchedulerComponent implements OnInit {

  selectedScheduler: Scheduler = new Scheduler();
  schedulers: Scheduler[];
  dataSource: MatTableDataSource<Scheduler>;
  searchKey: string = null;

  nameFilter = new FormControl();
  isAssignButtonDisabled: boolean = true;
  isTargetButtonDisabled: boolean = true;
  selection = new SelectionModel<Scheduler>(true, []);

  isRadionButtonClicked: boolean = false;

  assignedSchedulers: Scheduler[]

  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  length: number;
  pageSizeOptions: number[] = [15, 30, 45];
  schedulerPageRequest = new SchedulerPageRequest();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

 /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. 'clientName', 'projectName', */
 displayedColumns = ['selection', 'schedulerId', 'firstName', 'lastName', 'contactNumber', 'address1', 'address2', 'state', 'city', 'zip', 'clientName', 'assignedProjectNames'];
 constructor(
   private schedulerService: SchedulerService,
   public dialog: MatDialog,
   private _localStorage: LocalStorageService,
   private router: Router) {
 }

 ngOnInit() {
  this._localStorage.store('PageEvent', undefined);
   this.getSchedulers();
 }

 getSchedulers(event?: PageEvent, clearPagination?: boolean) {
  if(clearPagination){
    this._localStorage.store('PageEvent', undefined);
  }
   if (event != undefined) {
    this._localStorage.store('PageEvent', event);
     this.schedulerPageRequest.pageNum = event.pageIndex;
     this.schedulerPageRequest.pageSize = event.pageSize;
   }else if (event === undefined || event === null) {
     this.schedulerPageRequest.pageNum = 0;
     this.schedulerPageRequest.pageSize = 15;
   }
     this.schedulerPageRequest.sortBy = "firstName";
     this.schedulerPageRequest.sortDir = "ASC";
   if(this.searchKey!= undefined && this.searchKey != null){
     this.schedulerPageRequest.searchValue = this.searchKey.toLowerCase();
   }else{
     this.schedulerPageRequest.searchValue = '';
   }
   this.schedulerService.getSchedulers(this.schedulerPageRequest)
     .subscribe(result => {
       if (!result) {
         return;
       }
       console.log(result);
       this.schedulers = result.schedulers;
       this.dataSource = new MatTableDataSource(result.schedulers);
       this.dataSource.sort = this.sort;
 
       if (event != undefined) {
         this.pageIndex = event.pageIndex;
         this.pageSize = event.pageSize;
         this.length = result.totalCount;
       }
       if (event === undefined || event === null) {
         this.pageIndex = 0;
         this.pageSize = 15;
         this.length = result.totalCount;
       }
       this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
         this.dataSource.data = this.filterOptions(nameFilterValue);
       });
     }, error => console.log(error));
     return event;
 }

 openAssignDialog(): void {
   const dialogRef = this.dialog.open(AssignModalComponent, {
    panelClass: 'assign-sch-model',
     data:
       this.selectedScheduler
   });

   dialogRef.afterClosed().subscribe(result => {
     console.log("result " + result);
     this.getSchedulers(this._localStorage.retrieve('PageEvent'));
   });
 }

 openAssigntargetDialog(): void {
   const dialogRef = this.dialog.open(AssigntargetModalComponent, {
     panelClass: 'assign-sch-model',
     data:
       this.selectedScheduler
   });
   dialogRef.afterClosed().subscribe(result => {
     console.log("result " + result);
     this.getSchedulers(this._localStorage.retrieve('PageEvent'));
   });
 }

 reset() {
   this.isAssignButtonDisabled = true;
   this.isTargetButtonDisabled = true;
   this.isRadionButtonClicked = false;
   this.getSchedulers();
   this.selection.clear();
 }

 isAllSelected() {
   const numSelected = this.selection.selected.length;
   const numRows = this.dataSource.data.length;
   return numSelected === numRows;
 }

 toggle(row) {
   console.log(row.firstName + "<>" + this.selection.selected.includes(row))
   if (this.selection.selected.includes(row)) {
     this.selection.deselect(row)
   } else {
     this.selection.select(row)
   }
   if (this.selection.selected.length > 0) {
     this.isAssignButtonDisabled = false;
     this.isTargetButtonDisabled = false;
   } else {
     this.isAssignButtonDisabled = true;
     this.isTargetButtonDisabled = true;
   }
 }

 masterToggle() {
   this.isAllSelected() ?
     this.selection.clear() :
     this.dataSource.data.forEach(row => { this.selection.select(row) });
   if (this.selection.selected.length > 0) {
     this.isAssignButtonDisabled = false;
     this.isTargetButtonDisabled = false;
   } else {
     this.isAssignButtonDisabled = true;
     this.isTargetButtonDisabled = true;
   }
 }

 /* applyFilter(filterValue: string) {
   this.dataSource.filter = filterValue.trim().toLowerCase();
   this.dataSource.filter = filterValue;
 } */

 filterOptions(nameValue: string): Scheduler[] {
   if (!nameValue) {
     return this.schedulers;
   }
   const filtered = this.schedulers.filter((element) => {
     return (nameValue ? element.firstName.toLowerCase().includes
       (nameValue.toLowerCase()) : false) || (nameValue ? element.lastName.toLowerCase().includes
         (nameValue.toLowerCase()) : false)
   });
   return filtered;
 }

 customFilterPredicate() {
   const myFilterPredicate = function (data: Scheduler, filter: string): boolean {
     let searchString = JSON.parse(filter);
     return data.firstName.toString().trim().toLowerCase().indexOf(searchString.name.toLowerCase()) !== -1 &&
       data.lastName.toString().trim().toLowerCase().indexOf(searchString.name.toLowerCase()) !== -1;
   }
   return myFilterPredicate;
 }

 radiobuttonClick(event, scheduler: Scheduler): void {
   this.isRadionButtonClicked = true;
   this.isAssignButtonDisabled = false;
   if (scheduler.isAssigned) {
     this.isTargetButtonDisabled = false;
   } else {
     this.isTargetButtonDisabled = true;
   }
   this.selectedScheduler = scheduler;
 }

 onSearchClear() {
  this.searchKey = "";
  this.getSchedulers();
}

}